import { useStyles } from "./IssueNumberExpandedCell.styles";
import ActionPlanIcon from "pages/Corporate/RCA/images/action_plan_icon.svg";
import { IIssueNumberExpandedCell } from "./IssueNumberExpandedCellInterfaces";
import { useTranslation } from "react-i18next";

const IssueNumberExpandedCell = ({ issue }: IIssueNumberExpandedCell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.descriptionWrapper}>
            <img src={ActionPlanIcon} alt="Action plan icon" />
            <span>{`${t("rca.ap")}-${issue.display_number}`}</span>
        </div>
    );
};

export default IssueNumberExpandedCell;
